import { c as _c } from "react/compiler-runtime";
import type { Dispatch } from 'react';
import styles from './MainMenuButton.module.css';
import type { IMenuAction } from "src/components/menu/IMenuAction";
import { locale } from "@locale";

//#region [Props]
type MainMenuButtonProps = {
  dispatch: Dispatch<IMenuAction>;
  /** id of the menu popover this button opens */
  popoverTarget?: string;
};
//#endregion

//#region [Component]
// popoverTarget links the button to its menu, so a click on it is not a click outside the menu (which would close it first)
// and the button gets aria-expanded. The click itself is handled by the menu state: preventDefault() stops the browser from
// also toggling the popover, which would undo the state's change.
export default function MainMenuButton(t0) {
  const $ = _c(7);
  const {
    dispatch,
    popoverTarget
  } = t0;
  let t1;
  if ($[0] !== dispatch) {
    t1 = event => {
      event.preventDefault();
      dispatch({
        type: "TOGGLE_MENU"
      });
    };
    $[0] = dispatch;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const onClick = t1;
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className={styles.SHamburger}><span /></div>;
    t3 = <div>{locale.menu.menu}</div>;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  let t4;
  if ($[4] !== onClick || $[5] !== popoverTarget) {
    t4 = <button className={styles.SMainMenuButton} onClick={onClick} aria-label={locale.menu.menu} popoverTarget={popoverTarget}>{t2}{t3}</button>;
    $[4] = onClick;
    $[5] = popoverTarget;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  return t4;
}
//#endregion

//#region [Styles]
//#region [Styles]
// Converted to CSS Modules (MainMenuButton.module.css) preserving SMainMenuButton/SHamburger
//#endregion

//#endregion